import { Reveal } from "@/lib/motion";
import { useSiteContent } from "@/lib/useSiteContent";

export default function AdvisoryProcess() {
  const c = useSiteContent().process;
  return (
    <section id="process" data-testid="process-section" className="section-pad bg-[#FAFAF8]">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="md:max-w-3xl">
          <Reveal><p className="eyebrow">{c.eyebrow}</p></Reveal>
          <Reveal delay={0.05}>
            <h2 className="font-serif-luxe text-[#1D1D1F] text-4xl md:text-5xl leading-[1.08] mt-5">
              {c.heading}
            </h2>
          </Reveal>
        </div>

        <div className="relative mt-20">
          <div className="hidden md:block absolute left-0 right-0 top-6 h-px bg-gradient-to-r from-transparent via-[#B68D40]/40 to-transparent" />
          <div className="grid md:grid-cols-3 lg:grid-cols-6 gap-10 md:gap-6 relative">
            {(c.steps || []).map((s, i) => (
              <Reveal key={i} delay={i * 0.05}>
                <div data-testid={`process-step-${i}`} className="relative">
                  <div className="w-3 h-3 rounded-full bg-[#B68D40] mb-6 relative z-10" />
                  <div className="text-[0.7rem] uppercase tracking-[0.16em] text-[#B68D40] mb-2">
                    Step {String(i + 1).padStart(2, "0")}
                  </div>
                  <h3 className="font-serif-luxe text-xl md:text-2xl text-[#1D1D1F] leading-tight">{s.title}</h3>
                  <p className="text-[#616161] text-sm mt-3 leading-relaxed">{s.body}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
